module.exports = __webpack_public_path__ + "img/item-3.7a7a0522.png";